// FileGuard REST API fetch 래퍼 — 에러/타임아웃/헤더 일원화

export interface CallOptions {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  path: string;
  apiKey: string;
  jsonBody?: unknown;
  formData?: FormData;
  timeoutMs?: number;
}

export interface CallResult {
  ok: boolean;
  status: number;
  body: string;
  error?: string;
}

export async function callEndpoint(opts: CallOptions): Promise<CallResult> {
  const headers: Record<string, string> = {};
  if (opts.apiKey) headers['X-API-Key'] = opts.apiKey;

  let body: BodyInit | undefined;
  if (opts.formData) {
    body = opts.formData;
  } else if (opts.jsonBody !== undefined) {
    headers['Content-Type'] = 'application/json';
    body = JSON.stringify(opts.jsonBody);
  }

  const controller = new AbortController();
  const timeoutMs = opts.timeoutMs ?? 15000;
  const timer = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const res = await fetch(opts.path, { method: opts.method, headers, body, signal: controller.signal });
    const text = await res.text();
    return { ok: res.ok, status: res.status, body: text };
  } catch (e) {
    const msg = (e as Error).message || '연결 실패';
    return { ok: false, status: 0, body: '', error: `백엔드 연결 실패: ${msg}` };
  } finally {
    clearTimeout(timer);
  }
}
